export class SmallSlider{

	constructor(){

		this.slider = $('.c-small-slider');
		this.init();

	}


	init(){

		this.slider.slick({
			dots: false,
			slidesToShow: 4,
			slidesToScroll: 1,
			arrows: true,
			nextArrow: '.c-arrow--right',
			prevArrow: false,
			infinite: true,
			speed: 1000,
			fade: false,
			autoplay: true,
			autoplaySpeed: 2000,
			cssEase: 'linear',

			responsive: [
			{
				breakpoint: 1366,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				}
			},{
				breakpoint: 767,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
				}
			}
			]

		});

	}

}



// WEBPACK FOOTER //
// ./src/js/modules/small-slider.js